export const RPL_LEAD_TITLE = 'RPL Eligibility Check';

export type RplLeadPayload = {
  target_qualification: string;
  existing_qualifications: string;
  cpd_certificates: string;
  cpd_completion_dates: string;
  practice_duration: string;
  case_studies_count: string;
  has_before_after_photos: string;
  has_consultation_consent_forms: string;
  has_insurance_evidence: string;
  page_source?: string;
  rpl_terms_accepted?: boolean;
};

export const RPL_LEAD_FIELD_ROWS: ReadonlyArray<{
  key: keyof RplLeadPayload;
  label: string;
}> = [
  { key: 'target_qualification', label: 'Target qualification' },
  { key: 'existing_qualifications', label: 'Existing qualifications' },
  { key: 'cpd_certificates', label: 'CPD certificates held' },
  { key: 'cpd_completion_dates', label: 'CPD completion dates' },
  { key: 'practice_duration', label: 'Time practising treatment' },
  { key: 'case_studies_count', label: 'Case studies / treatment records' },
  { key: 'has_before_after_photos', label: 'Before/after photos' },
  {
    key: 'has_consultation_consent_forms',
    label: 'Consultation and consent forms',
  },
  { key: 'has_insurance_evidence', label: 'Insurance evidence' },
  { key: 'page_source', label: 'Page source' },
  { key: 'rpl_terms_accepted', label: 'RPL terms accepted' },
];

export const isRplLead = (lead?: {
  metadata?: { title?: string; type?: string };
  content?: { rpl?: RplLeadPayload };
}) => {
  if (!lead) {
    return false;
  }

  return (
    lead.metadata?.type === 'rpl-eligibility' ||
    lead.metadata?.title === RPL_LEAD_TITLE ||
    Boolean(lead.content?.rpl)
  );
};

export const getRplFromLead = (lead?: {
  content?: { rpl?: RplLeadPayload };
  metadata?: { rpl?: RplLeadPayload };
}) => lead?.content?.rpl || lead?.metadata?.rpl || null;

export const buildRplFieldRows = (rpl: RplLeadPayload | null | undefined) => {
  if (!rpl) {
    return [];
  }

  return RPL_LEAD_FIELD_ROWS.map(({ key, label }) => ({
    label,
    value:
      key === 'rpl_terms_accepted'
        ? rpl[key]
          ? 'Yes'
          : ''
        : String(rpl[key] || ''),
    multiline:
      key === 'existing_qualifications' ||
      key === 'cpd_certificates' ||
      key === 'cpd_completion_dates',
  })).filter((row) => row.value);
};

export const getRplLeadListSummary = (
  rpl: RplLeadPayload | null | undefined,
) => {
  if (!rpl?.target_qualification) {
    return 'RPL eligibility check';
  }

  return rpl.target_qualification;
};
